module.exports = __webpack_public_path__ + "static/media/get-logo1.6962099b.png";